import { Row } from "antd";
import React from "react";
import { useFirestoreConnect } from "react-redux-firebase";
import { FIRESTORE_DISCOUNT_CODES_TABLE } from "../../../../constants/FirestoreConstant";
import AddDiscount from "./AddDiscount";
import DiscountList from "./DiscountList";

const DiscountCodes = () => {
  // Deze pagina leest de collectie, dus abonneert de pagina zelf. Stond tot nu
  // toe in layouts/app-layout (op elke CMS-pagina) -- zie docs/cms-performance.md.
  useFirestoreConnect([{ collection: FIRESTORE_DISCOUNT_CODES_TABLE }]);
  return (
    <Row gutter={16}>
      <AddDiscount />
      <DiscountList />
    </Row>
  );
};

export default DiscountCodes;
